import { createClient } from '@supabase/supabase-js'

const supabaseUrl = import.meta.env.VITE_SUPABASE_URL
const supabaseAnonKey = import.meta.env.VITE_SUPABASE_ANON_KEY

if (!supabaseUrl || !supabaseAnonKey) {
  throw new Error('Missing Supabase environment variables')
}

export const supabase = createClient(supabaseUrl, supabaseAnonKey)

// Function to set user context for RLS policies
export async function setSupabaseUserContext(clerkUserId: string) {
  try {
    // For now, we'll rely on the ultra-permissive RLS policies
    // In the future, this could be enhanced with proper JWT authentication
    return true
  } catch (error) {
    console.warn('Error setting Supabase user context:', error)
    return false
  }
}

// Database types
export interface FinancialDataRow {
  id: number
  month: string
  date: string
  total_income: number
  total_cogs: number
  gross_profit: number
  total_expense: number
  net_ordinary_income: number
  quarter: string
  season: 'Winter' | 'Spring' | 'Summer' | 'Fall'
  year: number
  sde?: number
  sde_breakdown?: {
    'Business Personal': number
    'Farm Account': number
    'Meals': number
    'Net Income': number
    'Officer Life': number
    'Owner Salary': number
    'Personal Draw': number
    'Personal Property': number
    'Simple IRA': number
    'Travel & Entertainment': number
    'Vehicle Expense': number
    'SDE': number
  }
  created_at?: string
  updated_at?: string
}

// Transform database row to match existing FinancialData interface
export function transformFinancialData(row: FinancialDataRow) {
  return {
    month: row.month,
    date: new Date(row.date),
    totalIncome: row.total_income,
    totalCOGS: row.total_cogs,
    grossProfit: row.gross_profit,
    totalExpense: row.total_expense,
    netOrdinaryIncome: row.net_ordinary_income,
    quarter: row.quarter,
    season: row.season,
    year: row.year,
    sde: row.sde,
    sdeBreakdown: row.sde_breakdown
  }
}
